//#region
import { useState, useEffect, useRef } from 'react';
// material
import {
  Container, InputAdornment, Stack, Box, List, ListItem, ListItemIcon, ListItemText, TextField, Typography, DialogActions, Button, CircularProgress, Alert, MenuItem, Select, InputLabel,
  Pagination, Grid, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Modal, Fade, Autocomplete
} from "@mui/material";
import RefreshIcon from '@mui/icons-material/Refresh';
import AddIcon from '@mui/icons-material/Add';
import toast from 'react-hot-toast';
// components
import Page from "../components/Page";
import Loader from "./Loader";
import { DatasetsTable, DatasetsPopup } from '../components/_datasets/tables';
import Popup from '../components/Popup';
import Controls from '../components/controls/Controls';
import { getDatasets, addDatasets, updateDatasets, deleteDatasets, refreshDataSetsWithAthena } from '../config/services/datasets';
import { getDataSource } from '../config/services/dataSource';
import { addVersion } from '../config/services/config'
import { useNavigate } from 'react-router-dom';
// import SearchIcon from "../assets/icons/icon_search.svg";
import { ReactComponent as SearchIcon } from "../assets/icons/icon_search.svg"
import { ReactComponent as StringIcon } from "../assets/icons/icon_string.svg"
import { ReactComponent as DropDownIcon } from "../assets/icons/icon-angle-down.svg"

import { makeStyles } from '@mui/styles';

import ErrorOutlineSharpIcon from '@mui/icons-material/ErrorOutlineSharp';
import { debouncingFn } from '../utils/Reusables';


const useStyles = makeStyles((theme) => ({

  autoCompleteInp: {
    fontWeight: 'normal'
  },
  searchFieldListItem: {
    paddingTop: '0.6rem',
    paddingBottom: '0.6rem',
    '&:hover': {
      background: "#f1f1f1",
      zIndex: 9,
      "& $listItemDescription": {
        visibility: 'visible'
      },
      "& $searchFieldListMoreIcon": {
        visibility: 'visible'
      }
    },

  }
}));

export default function DatasetsApp() {
  const [openPopup, setOpenPopup] = useState(false);
  const [datasetsList, setDatasetsList] = useState([]);
  const [datasetListAll, setDatasetListAll] = useState([])
  const [recordForEdit, setRecordForEdit] = useState(null)
  const [dataSetsTotalCount, setDataSetListCount] = useState(0)
  const [search, setSearchValue] = useState('')
  const [sortObj, setSortObj] = useState({ sortKey: 'createdAt', sortOrder: '-1' })
  const [loader, setLoading] = useState(false)
  const [pageNo, setPagination] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [deleteObj, setDeleteObj] = useState({ dataSetId: '', dataSetName: '' })
  const [deletePopup, setDeletePopup] = useState(false)
  const [syncingDataSets, setSyncingDataSets] = useState(false)
  const [openAddDatasetPopup, setOpenAddDatasetPopup] = useState(false)
  const [datasetLoader, setDatasetLoader] = useState(false)
  const [datasetSelectValue, setdatasetSelectValue] = useState(null)
  const [dataSetSearch, setDataSetSearch] = useState('')
  const [restrictOption, setRestrictOption] = useState(false)
  const [openResyncPopup, setOpenResyncPopup] = useState(false)
  const [resyncTableName, setResyncTableName] = useState('')
  const [resyncType, setResyncType] = useState('')
  const [dataSourceList, setDataSourceList] = useState([])
  const [selectedDataSource, setSelectedDataSource] = useState({ dbName: 'All' })
  const [activeDataSource, setActiveDataSource] = useState(null)
  const classes = useStyles()


  const xPos = useRef(0)
  const navigate = useNavigate()

  const addOrEdit = (dataset, resetForm) => {
    if (dataset?._id) {
      updateDatasets(dataset)
        .then((res) => {
          resetForm()
          setOpenPopup(false);
          setRecordForEdit(null)
          fetchDatasetsList();
          toast.success(res?.message)
        });
    } else {
      addDatasets(dataset)
        .then((res) => {
          resetForm()
          setOpenPopup(false);
          setRecordForEdit(null)
          fetchDatasetsList();
          toast.success(res?.message)
        });;
    }
  }

  let totalPages = Number((dataSetsTotalCount / itemsPerPage).toFixed(0))

  const handleChangeDataSource = (e, value) => {
    setSelectedDataSource(value)
    const { _id } = value;
    fetchDatasetsList(_id)
  }

  const fetchDataSourceList = () => {
    let params = {}
    getDataSource(params).then((res) => {
      let sourceArr = [
        { dbName: 'All', _id: 'All' },
        { _id: 'Athena', dbName: 'Athena' }
      ]

      if (res?.result.length) {
        sourceArr.push(...res?.result)
        let activeDataSource = res?.result.find(ele => ele?.isActive === true)
        if (activeDataSource) {
          setActiveDataSource(activeDataSource)
        }
      }
      setDataSourceList(sourceArr);
    });
  }

  useEffect(() => fetchDataSourceList(), [])



  const fetchDatasetsList = (dataSourceKey) => {

    let sourceKey;
    if (dataSourceKey) {
      if (dataSourceKey !== 'All') {
        sourceKey = dataSourceKey
      }
    }
    else if (selectedDataSource && selectedDataSource?._id !== 'All') {
      sourceKey = selectedDataSource?._id
    }

    let params = { pageNo: (pageNo - 1), count: itemsPerPage, search, ...sortObj, ...(sourceKey && { dataSourceKey: sourceKey })}
    setLoading(true)
    getDatasets(params).then((res) => {
      setDatasetsList(res?.result);
      setDataSetListCount(res?.totalCount)
      setLoading(false)
    });
  }

  const fetchAllDatasetsList = (dataSourceKey) => {
    let sourceKey;
    if (dataSourceKey) {
      if (dataSourceKey !== 'All') {
        sourceKey = dataSourceKey
      }
    }
    else if (selectedDataSource && selectedDataSource?._id !== 'All') {
      sourceKey = selectedDataSource?._id
    }



    let params = { search: dataSetSearch,count:10, sortKey: 'displayName', sortOrder: '1', ...(sourceKey && { dataSourceKey: sourceKey }),joinFlag:true }
    setDatasetLoader(true)
    getDatasets(params).then((res) => {
      const datasets = filterJoinDataSets(res?.result)
      setDatasetListAll(datasets);
      setDatasetLoader(false)
    });
  }


  const handlePopupDatasetSearch = (e) => {
    let { value } = e.target
    setDataSetSearch(value)
  }

  useEffect(debouncingFn(fetchAllDatasetsList),[dataSetSearch]);


  const handleDataSetEdit = (params) => {
    updateDatasets(params)
      .then(response => {
        fetchDatasetsList();
        if (response?.result) {
          toast.success(response?.message)
        }
        else if (response?.data?.error) {
          toast.error(response?.data?.error?.errorMessage)
        }
      })

  }

  const openInPopup = dataset => {
    setRecordForEdit(dataset)
    setOpenPopup(true)
  }

  const deleteDataset = params => {
    setDeleteObj({ dataSetId: params?._id, dataSetName: params?.dataSetName })
    setDeletePopup(true)
  }

  const submitDeleteDataSet = () => {
    let { dataSetId } = deleteObj
    deleteDatasets({ dataSetId })
      .then(res => {
        handleCancelDelete()
        fetchDatasetsList()
        toast.success(res?.message)
      })
  }

  const handleResyncTableInput = (e) => {
    setResyncTableName(e.target.value)
  }

  const handlePagination = (e, pageNumber) => {
    setPagination(pageNumber)
  }

  const handleSearch = (e) => {
    let { value } = e.target
    //setPagination(1)
    setSearchValue(value, () => setPagination(1))
  }


  const handleCancelDelete = () => {
    setDeletePopup(false, () => {
      setDeleteObj({})
    })
  }

  const refreshDataSets = () => {

    const params = {}
    if (resyncType === 'getLatest') {
      params.getLatest = true
    }
    else if (resyncType === 'byName') {
      if (!resyncTableName) {
        toast.error('Table Name is required')
        return
      }
      else {
        params.tableName = resyncTableName
      }
    }

    setSyncingDataSets(true)
    refreshDataSetsWithAthena(params)
      .then(res => {
        if (res?.status === false) {
          toast.error(res?.message)
        }
        else {
          cancelResyncDatasets()
          toast.success(res?.message)
          fetchDatasetsList()
          addVersion({ version: new Date().getTime().toString() })
        }
        setSyncingDataSets(false)

      })
  }

  const addDataSets = () => {
    setOpenAddDatasetPopup(true)
    setDatasetLoader(true)
    const { _id } = selectedDataSource
    fetchAllDatasetsList(_id)
  }

  const filterJoinDataSets = (result) => {
    const datasets = result?.filter(res => !res?.joinDatasetsProps)
    return datasets;
  }

  const handleDatasetSelect = (value) => {
    setdatasetSelectValue(value);
  };

  const selectJoinDataSet = () => {
    if (datasetSelectValue && datasetListAll.length) {
      const selected = datasetListAll.find(ele => ele?._id === datasetSelectValue)
      if (selected) {
        selected.tableType = 'primary';
        xPos.current += 250
        selected.id = selected?._id;
        selected.mode = 'add';
        selected.type = 'CustomNode'
        selected.position = { x: 0, y: 0 };
        selected.connectable = false
        selected.data = { label: selected?.displayName, _id: selected.id, id: selected.id }
        //selected.position = { x: xPos.current, y: 0 };
        navigate(`/dataset/${selected?._id}/prepare`, { state: selected })
        setOpenAddDatasetPopup(false)
      }
    }
  }

  const cancelAddDataset = () => {
    setdatasetSelectValue(null)
    setOpenAddDatasetPopup(false)
  }

  const cancelResyncDatasets = () => {
    setResyncType('')
    setResyncTableName('')
    setOpenResyncPopup(false)
  }
  useEffect(
    debouncingFn(fetchDatasetsList),    
    [search, sortObj, pageNo, itemsPerPage]
  );

  const handleDatasetAccess = (action = 'new', redirect = null, data = null) => {
    if (window.innerWidth > 900) {
      if (action == 'new') {
        addDataSets();
      } else {
        navigate(redirect, data);
      }

    } else {
      setRestrictOption(true);
    }

  }


  return (
    <>
      <Page title="Extramarks | Datasets " className="main-container datasets_container">
        <Container className='table_max_width'>
          <Grid container alignItems="left" justifyContent="flex-start" mb={2} spacing={2.5} >
            <Grid item xs={12} sm={6} md={6} lg={6} className="datasets_header" >
              <TextField
                className={`inputRounded search-input`}
                type="search"
                placeholder="Search by Dataset name"
                onChange={handleSearch}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} >

              <Grid container justifyContent="flex-end" spacing={2.5}>
                {dataSourceList?.length > 2 &&
                  <Grid>

                    <Autocomplete
                      className="cm_rprt_setting_content report_form_ui_input_select pl-0 report_search_visual_dataset "
                      style={{ width: '120px', marginTop: '20px' }}
                      classes={{ input: classes.autoCompleteInp }}
                      size='small'
                      ListboxProps={{
                        className: "visual-dataset-list"
                      }}
                      disablePortal
                      disableClearable
                      popupIcon={<Box className="form_icon"><DropDownIcon /></Box>}
                      onChange={handleChangeDataSource}
                      value={selectedDataSource || null}
                      defaultValue={selectedDataSource || null}
                      getOptionLabel={option => (option?.dbName || option?.projectId || '')}

                      options={dataSourceList}
                      renderInput={(params) => <TextField {...params} />}
                      renderOption={(props, obj) => {
                        return (
                          <ListItem {...props} value={obj?._id} button
                            className={classes.searchFieldListItem + " report-list-item"} alignItems="flex-start"
                          >
                            <Grid container >
                              <Grid item xs={12}>
                                <Typography variant="body2" className="text-plain">{obj?.dbName || obj?.projectId} </Typography>
                              </Grid>
                            </Grid>
                          </ListItem>
                        )
                      }}
                    />
                  </Grid>

                }

                <Grid item xs={6} sm={6} md={6} lg={4} display="flex" justifyContent="flex-end" >
                  <Controls.Button
                    text={syncingDataSets ? "Syncing Datasets...." : "Resync Datasets"}
                    variant="contained"
                    disabled={syncingDataSets}
                    // startIcon={syncingDataSets ? <CircularProgress color="white" size={22} /> : <RefreshIcon />}
                    onClick={() => setOpenResyncPopup(true)}
                    className="cm_ui_button"
                  />
                </Grid>
                <Grid item xs={6} sm={6} md={6} lg={4} display="flex" justifyContent="flex-end" >
                  <Controls.Button
                    text="Add DataSets"
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={() => handleDatasetAccess()}
                    className="cm_ui_button"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {loader && <Loader />}
          {datasetsList?.length ? <DatasetsTable list={datasetsList} openInPopup={openInPopup} deleteDataset={deleteDataset} handleDataSetEdit={handleDataSetEdit}
            pageNo={pageNo} itemsPerPage={itemsPerPage} setLoading={setLoading} handleDatasetAccess={handleDatasetAccess} activeDataSource={activeDataSource} /> :
            <Alert severity="error">No Content Available!</Alert>}
        </Container>

        {
          datasetsList?.length ?
            <div className='center cm_pagination'>
              <Pagination count={totalPages} variant="outlined" color="primary" onChange={handlePagination} page={pageNo} />
            </div> : null
        }
      </Page>



      {/* <Popup
        title={recordForEdit ? "Edit Dataset" : "Add Dataset"}
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
      >
        <DatasetsPopup
          recordForEdit={recordForEdit}
          addOrEdit={addOrEdit}
        />
      </Popup> */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className="modal-root"
        open={openPopup}
        onClose={() => setOpenPopup(false)}
        closeAfterTransition
      >
        <Fade in={openPopup}>
          <Box className="modal-paper modal-box modal-md" id="transition-modal-title">
            <Box className="modal-header" >
              <Typography variant="subtitle1" className="modal-header-title" >{recordForEdit ? "Edit Dataset" : "Add Dataset"}</Typography>
            </Box>
            <Box className="modal-content">
              <DatasetsPopup
                recordForEdit={recordForEdit}
                addOrEdit={addOrEdit}
              />
            </Box>

          </Box>
        </Fade>
      </Modal>


      {/* <Popup title={`Are you sure to delete this DataSet "${deleteObj?.dataSetName}" ?`} openPopup={deletePopup} setOpenPopup={handleCancelDelete} onClose={false}>
        <DialogActions>
          <Button onClick={handleCancelDelete} color="primary" className="btn-cancel">Cancel</Button>
          <Button onClick={submitDeleteDataSet} color="error" autoFocus className="btn-primary">Delete</Button>
        </DialogActions>
      </Popup> */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className="modal-root"
        open={deletePopup}
        onClose={() => setDeletePopup(false)}
        closeAfterTransition
        setOpenPopup={handleCancelDelete}
      >
        <Fade in={deletePopup}>
          <Box className="modal-paper modal-box modal-sm" id="transition-modal-title">
            <Box className="modal-content-simple">
              <Typography variant="subtitle1" className="modal-heading-title-simple">{`Are you sure to delete this DataSet "${deleteObj?.dataSetName}" ?`}</Typography>
              {deleteObj?.isFolder ? <Typography variant="body2" className='text-small text-center'>(Deleting a folder will also delete all the reports inside that folder.)</Typography> : null}
              <Box className="modal-footer-simple">
                <Button onClick={handleCancelDelete} color="primary" className="report_form_ui_btn cancel mr-2" variant="outlined" > Cancel </Button>
                <Button onClick={submitDeleteDataSet} color="error" autoFocus className="report_form_ui_btn submit" variant="contained"> Delete </Button>
              </Box>
            </Box>
          </Box>
        </Fade>
      </Modal>

      <Popup title="Select a dataset"
        openPopup={openAddDatasetPopup}
        setOpenPopup={setOpenAddDatasetPopup}
      >
        <Grid item lg={12}> {datasetLoader && <Loader />} </Grid>
        <Grid container className="dataset-content">
          <FormControl fullWidth>
            <TextField className="cm_rprt_setting_content report_form_ui_input" onChange={handlePopupDatasetSearch} type="search" size="small" placeholder="Search for dataset"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start"> <SearchIcon /> </InputAdornment>
                ),
              }}
            />
          </FormControl>
          <div className="datasets_field_list  add_datasets_list">
            <List buttton="true" >
              {datasetListAll.map((dataSet, i) => (
                <ListItem key={i} className={`datasets_listitem ${dataSet._id === datasetSelectValue ? 'opt_highlight' : null}`} onClick={() => handleDatasetSelect(dataSet?._id)}>
                  <ListItemIcon>
                    <StringIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={dataSet?.displayName || dataSet?.dataSetName}
                    secondary={dataSet?.description ?? 'No Description'}
                  />
                </ListItem>
              ))}
            </List>
          </div>
          <DialogActions className="btn-group">
            <Button color="primary" onClick={cancelAddDataset} className="report_form_ui_btn cancel mr-2">Back</Button>
            <Button color="error" onClick={selectJoinDataSet} className="report_form_ui_btn submit">Select</Button>
          </DialogActions>

          {/* <FormControl component="fieldset"> */}
          {/* <FormLabel component="legend">DataSets</FormLabel> */}
          {/* <RadioGroup onChange={handleDatasetSelect}>
              {
                datasetListAll && datasetListAll.length && datasetListAll.map(d => (
                  <FormControlLabel value={d?._id} control={<Radio />} label={d?.dataSetName} />
                )) 
                      
              }
            </RadioGroup> */}
          {/* <Button
                  variant="contained"
                  text="Save"
                  color="primary"
                  size="small"
                  onClick={selectJoinDataSet}
                  className="select-dataset-btn"
                >Select Dataset
                
            </Button> */}

          {/* </FormControl> */}
        </Grid>
      </Popup>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className="modal-root"
        open={restrictOption}
        onClose={() => setRestrictOption(false)}
        closeAfterTransition
      >
        <Fade in={restrictOption}>
          <Box className="modal-paper modal-box modal-xs" id="transition-modal-title">
            <Box className="modal-content-simple text-center" sx={{ p: '1rem !important' }}>
              <ErrorOutlineSharpIcon color="primary" />
              <Typography variant="subtitle1" className="text-plain font-weight-normal">To use Custom Reports Feature, Switch to Desktop screen</Typography>
            </Box>
          </Box>
        </Fade>
      </Modal>



      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className="modal-root"
        open={openResyncPopup}
        onClose={() => setOpenResyncPopup(false)}
        closeAfterTransition
      >
        <Fade in={openResyncPopup}>
          <Box className="modal-paper modal-box modal-md" id="transition-modal-title">
            {syncingDataSets && <Loader />}
            <Box className="modal-header" >
              <Typography variant="subtitle1" className="modal-header-title" >Resync DataSets</Typography>
            </Box>
            <Box className="modal-content">

              <Stack direction="column">

                <Grid mb={2} width="100%">
                  <InputLabel>Resync Type</InputLabel>
                  <Select fullWidth defaultValue={''} onChange={e => setResyncType(e?.target?.value)}>
                    <MenuItem value="getLatest">Add New Datasets</MenuItem>
                    <MenuItem value="byName">Resync By Name</MenuItem>
                  </Select>
                </Grid>
                {

                  resyncType === "byName" && (
                    <Grid mb={2} width="100%">
                      <TextField className="cm_rprt_setting_content" onChange={handleResyncTableInput} type="text" size="large" placeholder="Table Name"
                      />
                    </Grid>)
                }
                <div>
                  <Controls.Button
                    className="report_form_ui_btn cancel mr-2"
                    color="secondary"
                    text="Cancel"
                    onClick={cancelResyncDatasets}
                  />
                  <Controls.Button
                    className="report_form_ui_btn submit"
                    type="submit"
                    text="submit"
                    onClick={refreshDataSets}
                    disabled={syncingDataSets}
                  />
                </div>
              </Stack>
            </Box>

          </Box>
        </Fade>
      </Modal>


    </>
  );
}
